import * as React from 'react';

import { computeText } from '@/locales/utils';
import { Input } from '@/components/form/Input';
import { FormattedMessage, useIntl } from 'react-intl';
import { Text } from '@/components/atoms/Text';
import { SvyButton } from '@/components/savory/SvyButton';
import { confirm } from '@/core/asyncActions/confirm';
import { useAddUserToRestaurantMutation } from '@/services/innovorder/adminTools/adminTools.endpoints';
import { FormControl, FormControls, SuccessMessage } from '../AdminTools.style';
import { safeMutate } from '@/utils/errors';
import { Form } from '@/core/form/Form';

export type AddUserToRestaurantInputs = {
    email: string;
    restaurantId: string;
};

const AddUserToRestaurant: React.FunctionComponent = () => {
    const intl = useIntl();

    const [addUserToRestaurant, { isSuccess }] = useAddUserToRestaurantMutation();

    const handleSubmitForm = async ({ email, restaurantId }: AddUserToRestaurantInputs) => {
        const hasConfirmed = await confirm(computeText(intl, 'adminTools.confirmModal.description'));
        if (hasConfirmed) {
            await safeMutate(
                addUserToRestaurant({
                    email,
                    restaurantId,
                }),
            );
        }
    };

    return (
        <Form<AddUserToRestaurantInputs>>
            {({ handleSubmit }) => {
                return (
                    <>
                        <Text type="large" text="brand.adminTools.addUserToRestaurant.title" />
                        <FormControls>
                            <FormControl>
                                <Input
                                    name="email"
                                    rules={{ required: computeText(intl, 'field.required') }}
                                    placeholder="brand.adminTools.addUserToRestaurant.form.placeholder.email"
                                    labelId="brand.adminTools.addUserToRestaurant.form.email"
                                />
                            </FormControl>
                            <FormControl>
                                <Input
                                    name="restaurantId"
                                    rules={{ required: computeText(intl, 'field.required') }}
                                    placeholder="brand.adminTools.addUserToRestaurant.form.placeholder.restaurantId"
                                    labelId="brand.adminTools.addUserToRestaurant.form.restaurantId"
                                />
                            </FormControl>
                            <SvyButton onClick={handleSubmit(handleSubmitForm)}>
                                <FormattedMessage id="button.validate" />
                            </SvyButton>
                            {isSuccess && <SuccessMessage text="brand.adminTools.addUserToRestaurant.form.success" />}
                        </FormControls>
                    </>
                );
            }}
        </Form>
    );
};

export default AddUserToRestaurant;
